import { render, staticRenderFns } from "./ProjectDialog.vue?vue&type=template&id=72b3b14f"
import script from "./ProjectDialog.vue?vue&type=script&lang=ts"
export * from "./ProjectDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports